import { render, staticRenderFns } from "./advertisingForm.vue?vue&type=template&id=1e85a068&scoped=true&"
import script from "./advertisingForm.vue?vue&type=script&lang=js&"
export * from "./advertisingForm.vue?vue&type=script&lang=js&"
import style0 from "./advertisingForm.vue?vue&type=style&index=0&id=1e85a068&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e85a068",
  null
  
)

export default component.exports